import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { inputCls, labelCls } from "./shared";

const EMPTY_FORM = { email: "", name: "", password: "" };

export default function ModeratorsTab() {
  const [mods, setMods] = useState([]);
  const [form, setForm] = useState(EMPTY_FORM);

  const load = useCallback(() => {
    api.get("/admin/moderators").then((r) => setMods(r.data)).catch((e) => console.error("Falha ao carregar moderadores:", e));
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/moderators", form);
      toast.success("Moderador cadastrado");
      setForm(EMPTY_FORM);
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <form onSubmit={add} className="card-metric space-y-4 h-fit">
        <h3 className="text-lg font-semibold text-white">Cadastrar moderador de chat</h3>
        <div>
          <label className={labelCls}>Nome</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} data-testid="moderator-name-input" />
        </div>
        <div>
          <label className={labelCls}>E-mail</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="moderator-email-input" />
        </div>
        <div>
          <label className={labelCls}>Senha de acesso</label>
          <input required type="text" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} data-testid="moderator-password-input" />
        </div>
        <button type="submit" className="btn-primary" data-testid="admin-add-moderator-btn">
          <Plus size={15} className="inline mr-1" /> Cadastrar moderador
        </button>
      </form>
      <div className="space-y-3">
        {mods.map((m) => (
          <div key={m.id} className="card-metric flex items-center justify-between" data-testid={`moderator-row-${m.email}`}>
            <div>
              <p className="font-semibold text-white">{m.name}</p>
              <p className="text-xs text-slate-400 font-data">{m.email}</p>
            </div>
            <button onClick={async () => { if (window.confirm("Remover moderador?")) { await api.delete(`/admin/moderators/${m.id}`); load(); } }}
              className="p-1.5 text-red-400 hover:bg-red-500/10 rounded" data-testid={`delete-moderator-${m.email}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        {mods.length === 0 && <p className="text-sm text-slate-500">Nenhum moderador cadastrado.</p>}
      </div>
    </div>
  );
}
